namespace $.$$ {
	export class $shm_hitalama_map_borderwidth extends $.$shm_hitalama_map_borderwidth {
		
		border_width_selected( next?: string ): string {
			if( next ) this.border_width( Number( next ) )
			return next ?? ''
		}

		border_width_suggests(): readonly string[] {
			return this.border_width_options().map( width => width.toString() )
		}
		
	}
}
